var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColors(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "greenGradient",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4ade80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#22c55e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellowGradient",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fde047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#facc15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grayGradient",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#aaaaaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#cccccc"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dangerStripes",
    patternUnits: "userSpaceOnUse",
    width: 20,
    height: 20,
    viewBox: "0 0 10 10",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 10,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 5,
    height: 10,
    fill: "#ff0000"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "brownStripes",
    patternUnits: "userSpaceOnUse",
    width: 20,
    height: 20,
    viewBox: "0 0 10 10",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 10,
    fill: "#65350f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 5,
    height: 10,
    fill: "#9a7b4f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColors);
export default __webpack_public_path__ + "static/media/colors.44812b2d1f5d2546684b230bf2f5d96e.svg";
export { ForwardRef as ReactComponent };